class Storage {
  static set (name, value, remeber) {
    window.document.cookie = name + '=' + value + ';path=/;'
    if (remeber) {
      window.localStorage.setItem(name, value)
    }
  }

  static setLocal (name, value) {
    window.localStorage.setItem(name, value)
  }

  static getLocal (name) {
    return window.localStorage.getItem(name)
  }

  static removeLocal (name) {
    return window.localStorage.removeItem(name)
  }

  static get (name) {
    let value = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
    value = value ? value[2] : null
    if (!value) {
      value = window.localStorage.getItem(name)
    }
    return value
  }

  static remove (name) {
    window.document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT'
    window.localStorage.removeItem(name)
  }

  static removeAll () {
    let cookies = window.document.cookie.split(';')

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i]
      let eqPos = cookie.indexOf('=')
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
      window.document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT'
    }
    window.localStorage.clear()
  }
}

export default Storage
